import React from 'react'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Caption from 'LuxKit/Typography/Caption'
import FullArrow from 'components/utils/Arrows/FullArrow'

interface Props {
  duration?: string
}

function FlightArrowGroup({ duration }: Props) {
  return (
    <VerticalSpacer gap={4}>
      <Caption align="center" variant="medium">
        {duration}
      </Caption>
      <FullArrow />
    </VerticalSpacer>
  )
}

export default React.memo(FlightArrowGroup)
